/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Publish_Export_AbortedInputs */



/**
* | output |
* | --- |
* | "Subtitle export was aborted" |
*
* @param {Work_Order_Publish_Export_AbortedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_export_aborted = /** @type {((inputs?: Work_Order_Publish_Export_AbortedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_Export_AbortedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("L’exportation des sous-titres a été annulée")
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Export der Untertitel wurde abgebrochen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("L'esportazione dei sottotitoli è stata interrotta")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт субтитров был прерван.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Se canceló la exportación de subtítulos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("字幕导出已中止")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕のエクスポートが中止されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपशीर्षक निर्यात रद्द कर दिया गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("A exportação de legendas foi cancelada.")
	return /** @type {LocalizedString} */ ("Subtitle export was aborted")
});